module.exports = __webpack_public_path__ + "img/damen.8959a694.png";